export class Protocol {
  public static readonly YATUNG_URL: string = process.env.REACT_APP_YATUNG_URL || 'https://api-test.yatung.com.tw/api/';
  public static readonly YATUNG_AUTH: string =
    process.env.REACT_APP_YATUNG_AUTH || 'https://api-test.yatung.com.tw/auth/CM/ATH/';
  public static readonly YATUNG_API_ROOT: string =
    process.env.REACT_APP_YATUNG_API_ROOT || 'https://yatung-server.aiv.com.tw/api';
  public static readonly YATUNG_ROOT: string = process.env.REACT_APP_YATUNG_ROOT || 'https://yatung-server.aiv.com.tw';
}
